/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formvalidation_Loginnotallowed3Inputs */

const en_formvalidation_loginnotallowed3 = /** @type {(inputs: Formvalidation_Loginnotallowed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User is not able to log in`)
};

/**
* | output |
* | --- |
* | "User is not able to log in" |
*
* @param {Formvalidation_Loginnotallowed3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formvalidation_loginnotallowed3 = /** @type {((inputs?: Formvalidation_Loginnotallowed3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formvalidation_Loginnotallowed3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formvalidation_loginnotallowed3(inputs)
});
export { formvalidation_loginnotallowed3 as "formValidation_loginNotAllowed" }